import baseStyled, { css as baseCss, ThemedCssFunction, ThemedStyledInterface } from 'styled-components';
import { ConsumableOverviewTheme } from './themes/types';
import Button from '@plasma/ui.general.button';

const styled = baseStyled as ThemedStyledInterface<ConsumableOverviewTheme>;
const css = baseCss as ThemedCssFunction<ConsumableOverviewTheme>;

export const ConsumableOverview = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: hidden;
`;

export const StyledSpan = styled.span`
  ${({ theme }) => css`
    background-color: ${theme.mode.consumableOverview.profileHeaderBG};
  `}
  font-size: 14px;
  color: white;
  font-weight: bold;
  margin-left: 10px;
  margin-right: 10px;
  padding: 8px;
  border-radius: 5px;
  border: 1px solid black;
  width: 5vw;
  align-items: center;
  justify-content: center;
`;

export const DifferenceContainer = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.mode.consumableOverview.differenceContainerBG};
    color: ${theme.mode.consumableOverview.differenceContainerFontColor};
  `}
  margin: 15px;
  padding: 8px;
  border-radius: 3px;
  font-weight: bold;
`;

export const NormalButton = styled.button`
  ${({ theme }) => css`
    background-color: ${theme.mode.consumableOverview.normalButtonBGColor};
    border: ${theme.mode.consumableOverview.normalButtonBorderColor};
  `}
  padding: 0.3vh 0.8vh;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NormalPlasmaButton = styled(Button)`
  ${({ theme }) => css`
    background-color: ${theme.mode.consumableOverview.normalButtonBGColor} !important;
    border: ${theme.mode.consumableOverview.normalButtonBorderColor} !important;
  `}
`;

export const Table = styled.table`
  width: 100%;
  margin-left: 1vh;
  border-collapse: collapse;
`;

export const TableHeader = styled.thead`
  background-color: ${({ theme }) => theme.mode.consumableOverview.backgroundColor};
  position: sticky;
  top: 0;
`;

export const TableHeadingRow = styled.tr`
  background-color: ${({ theme }) => theme.mode.consumableOverview.backgroundColorLight};
  justify-content: left;
  height: 35px;
`;

export const TableHeadingCell = styled.th`
  font-weight: bold;
  border-left: 1px solid ${({ theme }) => theme.mode.consumableOverview.borderColor};
  color: ${({ theme }) => theme.mode.consumableOverview.textColorLight};
  border-bottom: 1px solid ${({ theme }) => theme.mode.consumableOverview.borderColor};
  background-color: ${({ theme }) => theme.mode.consumableOverview.backgroundColor};
`;

export const TableRow = styled.tr<{ isLight: boolean }>`
  background-color: ${({ isLight, theme }) =>
    isLight ? theme.mode.consumableOverview.backgroundColorLight : theme.mode.consumableOverview.backgroundColorDark};
  height: 35px;
  &:hover {
    background-color: ${({ theme }) => theme.mode.consumableOverview.hoverBackgroundColor};
  }
`;

export const TableCell = styled.td<{ backgroundColor?: boolean }>`
  background-color: ${({ backgroundColor, theme }) => (backgroundColor ? theme.mode.consumableOverview.highlightCellBG : 'transparent')};
  border: 1px solid ${({ theme }) => theme.mode.consumableOverview.borderColor};
  color: ${({ theme }) => theme.mode.consumableOverview.textColor};
  padding: 4px 10px;
`;

export const LinkCell = styled.span<{ isDrawingAvailable: boolean }>`
  font-weight: ${({ isDrawingAvailable }) => (isDrawingAvailable ? 'bold' : '')};
  // Links use the theme's link colour; plain values inherit the cell's text colour so they stay readable in both themes.
  color: ${({ isDrawingAvailable, theme }) => (isDrawingAvailable ? theme.mode.consumableOverview.linkColor : 'inherit')};
  cursor: ${({ isDrawingAvailable }) => (isDrawingAvailable ? 'pointer' : '')};
  &:hover {
    text-decoration: ${({ isDrawingAvailable }) => (isDrawingAvailable ? 'underline' : 'none')};
  }
`;

export const SpecialValueContainer = styled.div`
  min-width: 150px;
`;

export const CartIndicator = styled.div<{ itemsInCart: number; isSpecialValue: boolean }>`
  background-color: ${({ isSpecialValue, itemsInCart, theme }) =>
    isSpecialValue
      ? 'lightgrey'
      : itemsInCart === 0
        ? 'grey'
        : theme.mode.consumableOverview.cartIndicatorBG || '#f0f5f5'};
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  border-left: 1px solid black;
  border-radius: 2px;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  height: 26px;
  color: ${({ itemsInCart }) => (itemsInCart === 0 ? 'white' : 'red')};
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CartButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;
`;

export const CartButton = styled(Button)<{ disabled: boolean; top?: boolean }>`
  width: 20px !important;
  height: 13px !important;
  border-left: none !important;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;
